import { useEffect, useRef, useState } from 'react';
import { gsap } from 'gsap';
import { ScrollTrigger } from 'gsap/ScrollTrigger';
import useMagnetic from '../hooks/useMagnetic';
import { scrollToSection } from '../hooks/useSmoothScroll';
import './About.css';

gsap.registerPlugin(ScrollTrigger);

const CARDS = [
  { text: 'Harness the Sun',    desc: 'Panels tuned to Indian sunlight.' },
  { text: 'Power Your World',   desc: 'Steady output from first light to dusk.' },
  { text: 'Cut Energy Bills',   desc: 'Up to 90% off your monthly power cost.' },
  { text: 'Build a Greener Future', desc: 'Clean energy that outlasts its payback.' },
];

export default function About() {
  const sectionRef = useRef(null);
  const cardsRef   = useRef([]);
  const labelRef   = useRef(null);
  const btnRef     = useMagnetic(0.4);
  const [hovered, setHovered] = useState(null);

  useEffect(() => {
    const ctx = gsap.context(() => {
      gsap.from(labelRef.current, {
        opacity: 0, y: 10, duration: 0.6, ease: 'power2.out',
        scrollTrigger: { trigger: sectionRef.current, start: 'top 80%' }
      });
      gsap.from(cardsRef.current, {
        opacity: 0, y: 30, duration: 0.7, stagger: 0.1, ease: 'power3.out',
        scrollTrigger: { trigger: sectionRef.current, start: 'top 70%' }
      });
    }, sectionRef);
    return () => ctx.revert();
  }, []);

  const scrollToEnquiry = () => scrollToSection('#enquiry');

  return (
    <section className="section section--flow about-section" id="about" ref={sectionRef}>
      <p className="eyebrow about-label" ref={labelRef}>Our Philosophy</p>

      <div className={`about-cards${hovered !== null ? ' has-hover' : ''}`}>
        {CARDS.map((c, i) => (
          <div
            key={i}
            className={`acard${hovered === i ? ' active' : ''}`}
            ref={el => cardsRef.current[i] = el}
            onMouseEnter={() => setHovered(i)}
            onMouseLeave={() => setHovered(null)}
          >
            <div className="acard-fill" />
            <h2 className="acard-text">{c.text}</h2>
            <p className="acard-desc">{c.desc}</p>
            <span className="acard-arrow">
              <svg width="14" height="14" viewBox="0 0 12 12" fill="none">
                <path d="M1 6h10M6 1l5 5-5 5" stroke="currentColor" strokeWidth="1.2" strokeLinecap="round" strokeLinejoin="round"/>
              </svg>
            </span>
          </div>
        ))}
      </div>

      <div className="about-footer">
        <p>Solar energy solutions across India</p>
        <button className="btn" ref={btnRef} onClick={scrollToEnquiry}>
          <span>Let's Talk</span>
          <svg width="12" height="12" viewBox="0 0 12 12" fill="none">
            <path d="M1 6h10M6 1l5 5-5 5" stroke="currentColor" strokeWidth="1.2" strokeLinecap="round" strokeLinejoin="round"/>
          </svg>
        </button>
      </div>
    </section>
  );
}
